// import React from "react";
// import {
//   BarChart3,
//   CheckCircle,
//   ArrowRight,
//   Zap,
//   Users,
//   TrendingUp,
//   Layers,
// } from "lucide-react";

// export default function ERPProductPage() {
//   const features = [
//     {
//       icon: Layers,
//       title: "Inventory Management",
//       description:
//         "Real-time inventory tracking across warehouses with automated reorder points.",
//     },
//     {
//       icon: BarChart3,
//       title: "Financial Management",
//       description:
//         "Accounting, invoicing, budgeting, and multi-currency financial reporting.",
//     },
//     {
//       icon: TrendingUp,
//       title: "Supply Chain Management",
//       description:
//         "Complete visibility from procurement to delivery with optimized workflows.",
//     },
//     {
//       icon: Users,
//       title: "Human Resources",
//       description:
//         "Employee records, payroll, attendance, and performance management.",
//     },
//     {
//       icon: Zap,
//       title: "Real-time Analytics",
//       description:
//         "Smart dashboards and reports for faster, data-driven decisions.",
//     },
//     {
//       icon: Layers,
//       title: "Multi-branch Support",
//       description:
//         "Centralized control with branch-level operations and reporting.",
//     },
//   ];

//   const modules = [
//     { name: "Sales Management", description: "Orders, quotations, invoicing" },
//     { name: "Purchase Management", description: "Vendors, POs, GRN" },
//     { name: "Production", description: "BOM, production planning, QC" },
//     { name: "Warehouse", description: "Stock, bins, transfers" },
//     { name: "Finance", description: "GL, AP, AR, budgeting" },
//     { name: "HR & Payroll", description: "Attendance, payroll, appraisals" },
//   ];

//   const benefits = [
//     "Increase operational efficiency",
//     "Reduce inventory and operational costs",
//     "Improve cash flow visibility",
//     "Accurate real-time business insights",
//     "Better compliance and audit readiness",
//     "Scalable for growing businesses",
//   ];

//   const implementation = [
//     {
//       phase: "Discovery & Planning",
//       duration: "2–4 Weeks",
//       details: "Requirement analysis and solution planning.",
//     },
//     {
//       phase: "Customization & Setup",
//       duration: "4–6 Weeks",
//       details: "System configuration and integrations.",
//     },
//     {
//       phase: "Data Migration",
//       duration: "2–4 Weeks",
//       details: "Secure migration from legacy systems.",
//     },
//     {
//       phase: "Testing & Training",
//       duration: "3–4 Weeks",
//       details: "UAT, user training, and documentation.",
//     },
//     {
//       phase: "Go-Live & Support",
//       duration: "1–2 Weeks",
//       details: "Deployment and post-launch support.",
//     },
//   ];

//   return (
//     <main className="bg-white">
//       {/* HERO */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://i.pinimg.com/736x/f1/be/b1/f1beb1cc31aa53560688ff3a981d41ca.jpg')",
//           }}
//         />

//         {/* Dark overlay */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             {/* ERP Title */}
//             <h1 className="text-4xl sm:text-5xl font-light mb-2 tracking-tight">
//               ERP
//             </h1>

//             {/* Full form */}
//             <p className="text-sm uppercase tracking-widest text-blue-300 mb-4 font-semibold">
//               Enterprise Resource Planning
//             </p>

//             {/* Description */}
//             <p className="text-lg text-slate-300 max-w-2xl mb-6 font-light">
//               One powerful platform to manage finance, inventory, HR, and core
//               business operations seamlessly across your organization.
//             </p>

//             {/* Actions */}
//             <div className="flex gap-4 flex-wrap">
//               <button className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors">
//                 Request Demo <ArrowRight className="w-4 h-4" />
//               </button>

//               <button className="inline-flex items-center gap-2 border border-white/30 text-white px-7 py-3 rounded-md font-medium hover:bg-white/10 transition-colors">
//                 Contact Sales
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* WHAT IS ERP */}
//       <section className="py-16">
//         <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-3xl font-bold mb-4">What is ERP?</h2>
//             <p className="text-gray-600 mb-4">
//               ERP (Enterprise Resource Planning) is a centralized business
//               system that integrates core processes such as finance, inventory,
//               HR, sales, and operations into a single platform.
//             </p>
//             <p className="text-gray-600 mb-6">
//               Our ERP eliminates data silos, improves accuracy, and gives
//               management real-time visibility into the entire organization.
//             </p>
//             <ul className="space-y-3">
//               {[
//                 "Centralized business data",
//                 "Real-time analytics & reporting",
//                 "Improved productivity",
//                 "Scalable & secure cloud platform",
//               ].map((item, i) => (
//                 <li key={i} className="flex gap-3 items-center">
//                   <CheckCircle className="text-blue-900" size={20} />
//                   <span className="text-gray-700 text-sm">{item}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <img
//             src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80"
//             alt="ERP Dashboard"
//             className="rounded-xl shadow-lg border"
//           />
//         </div>
//       </section>

//       {/* FEATURES */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4">
//           <h2 className="text-3xl font-bold text-center mb-12">Key Features</h2>
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {features.map((f, i) => {
//               const Icon = f.icon;
//               return (
//                 <div
//                   key={i}
//                   className="bg-white p-6 rounded-lg border hover:shadow-lg transition"
//                 >
//                   <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
//                     <Icon className="text-blue-900" size={24} />
//                   </div>
//                   <h3 className="font-bold mb-2">{f.title}</h3>
//                   <p className="text-sm text-gray-600">{f.description}</p>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* MODULES */}
//       <section className="py-16">
//         <div className="max-w-7xl mx-auto px-4">
//           <h2 className="text-3xl font-bold text-center mb-12">Core Modules</h2>
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {modules.map((m, i) => (
//               <div
//                 key={i}
//                 className="bg-blue-50 p-5 rounded-lg border hover:border-blue-900"
//               >
//                 <h3 className="font-bold mb-1">{m.name}</h3>
//                 <p className="text-sm text-gray-600">{m.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* BENEFITS */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4">
//           <h2 className="text-3xl font-bold text-center mb-12">
//             Business Benefits
//           </h2>
//           <div className="grid md:grid-cols-2 gap-5">
//             {benefits.map((b, i) => (
//               <div
//                 key={i}
//                 className="bg-white p-5 rounded-lg border flex gap-3"
//               >
//                 <CheckCircle className="text-blue-900" />
//                 <span>{b}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* IMPLEMENTATION */}
//       <section className="py-16">
//         <div className="max-w-7xl mx-auto px-4">
//           <h2 className="text-3xl font-bold text-center mb-12">
//             Implementation Timeline
//           </h2>
//           <div className="space-y-4">
//             {implementation.map((s, i) => (
//               <div
//                 key={i}
//                 className="bg-gray-50 p-5 rounded-lg border flex gap-4"
//               >
//                 <div className="w-10 h-10 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold">
//                   {i + 1}
//                 </div>
//                 <div>
//                   <h3 className="font-bold">{s.phase}</h3>
//                   <p className="text-sm text-gray-600">{s.details}</p>
//                   <p className="text-xs font-semibold text-blue-900 mt-1">
//                     {s.duration}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white text-center">
//         <h2 className="text-3xl font-bold mb-4">
//           Transform Your Business with ERP
//         </h2>
//         <p className="mb-8 opacity-90">
//           Book a personalized demo and see how our ERP fits your business.
//         </p>
//         <button className="bg-white text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100">
//           Request Demo
//         </button>
//       </section>
//     </main>
//   );
// }

import React from "react";
import {
  BarChart3,
  CheckCircle2,
  ArrowRight,
  Zap,
  Users,
  TrendingUp,
  Globe2,
  Box,
  LayoutDashboard,
  ShieldCheck,
  Cpu,
  Workflow,
} from "lucide-react";
 import { Link } from "react-router-dom";

export default function ERPProductPage() {
  const features = [
    {
      icon: Box,
      title: "Intelligent Inventory",
      description:
        "Algorithmic inventory tracking with automated replenishment and multi-node synchronization.",
    },
    {
      icon: BarChart3,
      title: "Fiscal Governance",
      description:
        "Unified accounting with multi-currency support, automated reconciliation, and audit-ready reporting.",
    },
    {
      icon: TrendingUp,
      title: "Supply Chain Velocity",
      description:
        "End-to-end transparency from procurement to fulfillment with predictive bottleneck detection.",
    },
    {
      icon: Users,
      title: "Human Capital Management",
      description:
        "Centralized employee lifecycle management, global payroll, and performance metrics.",
    },
    {
      icon: LayoutDashboard,
      title: "Executive Intelligence",
      description:
        "Real-time BI dashboards that translate complex data into actionable strategic insights.",
    },
    {
      icon: Globe2,
      title: "Multi-Entity Sync",
      description:
        "Seamlessly manage international branches with consolidated reporting and local compliance.",
    },
  ];

  return (
    <main className="bg-white selection:bg-indigo-100">
      {/* ========== HERO SECTION ========== */}

      <section className="relative h-[500px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://i.pinimg.com/736x/f1/be/b1/f1beb1cc31aa53560688ff3a981d41ca.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/95 to-transparent" />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-4">
              Enterprise Solution
            </div>

            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-slate-500">Resource</span>{" "}
              Planning.
            </h1>

            <p className="text-base text-slate-400 text-white max-w-lg mb-8 leading-relaxed font-light">
              A high-performance digital core designed to integrate fragmented
              operations into a unified, intelligent ecosystem.
            </p>

            <div className="flex gap-3 flex-wrap">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Get Started <ArrowRight size={16} />
              </Link>

              <Link
                to="/contact"
                className="border border-slate-700 text-slate-300 px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-slate-800 transition-all"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* ========== CORE CONCEPT ========== */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-4">
              The Digital Core
            </span>
            <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight">
              Unified Operations. Absolute Visibility.
            </h2>
            <p className="text-slate-600 mb-8 leading-relaxed">
              Our ERP solution is a strategic framework that eliminates data
              fragmentation. We consolidate your fragmented workflows into a
              single source of truth, allowing for seamless horizontal scaling.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Centralized Data Architecture",
                "Predictive AI Analytics",
                "Scalable Cloud Security",
                "Global Compliance Engine",
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircle2 className="text-indigo-600" size={16} />
                  <span className="text-sm font-semibold text-slate-700">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-indigo-100/50 rounded-3xl -z-10 blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80"
              alt="Dashboard"
              className="rounded-2xl shadow-2xl border border-slate-100"
            />
          </div>
        </div>
      </section>
      {/* ========== OPERATIONAL IMPACT (REFINED CARDS) ========== */}
      <section className="py-24 bg-slate-50 overflow-hidden border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Strategic Value
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Engineered Operational Impact
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:border-indigo-500/30 transition-all duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-slate-50 text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                <Cpu size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-indigo-600 transition-colors">
                Seamless Integration
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Connect legacy hardware and third-party SaaS platforms through
                our robust API mesh, ensuring zero downtime during transition.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:border-indigo-500/30 transition-all duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-slate-50 text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                <Workflow size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-indigo-600 transition-colors">
                Process Automation
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Eliminate manual entry errors with intelligent workflows that
                handle everything from invoice matching to stock reordering.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:border-indigo-500/30 transition-all duration-300 group">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-slate-50 text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                <ShieldCheck size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-indigo-600 transition-colors">
                Data Governance
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Role-based access controls and encrypted data silos ensure that
                your enterprise intelligence remains secure and compliant.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ========== KEY FEATURES ========== */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Enterprise Capabilities
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="bg-white p-8 rounded-2xl border border-slate-200 hover:border-indigo-500/30 transition-all group"
              >
                <div className="w-10 h-10 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                  <f.icon size={20} />
                </div>
                <h3 className="font-bold text-slate-900 mb-3 tracking-tight">
                  {f.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed font-light">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ========== FINAL CTA ========== */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500 rounded-full blur-[120px]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6 tracking-tight">
            Redefine Your Business Velocity.
          </h2>
          <p className="text-slate-400 mb-8 font-light max-w-xl mx-auto leading-relaxed">
            Transition to a unified enterprise framework. Experience the power
            of total visibility across every business node.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Technical Demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}